import React, { FC, useContext, useState } from 'react'
import { AppStateContext } from '@components/layouts/DynamicLayout'
import Modal from '@components/ui/modal'
import Loader from '@components/ui/loader'
import { Formik } from 'formik'
import Text from '@components/ui/text'
import { DOSSIER_FORM } from '@components/ui/TNUrbanRequestDetails/__index.utils'

type Props = {
	isOpen: boolean
	dossier?: DOSSIER_FORM
	description?: string
	isDefaultCancelReason?: boolean
	onCancel: () => void
	onRefreshRepere?: () => Promise<void>
}

const PaymentRedirectModal: FC<Props> = ({
	isOpen,
	dossier,
	onCancel,
	description,
	onRefreshRepere
}) => {
	const { pageData } = useContext(AppStateContext)
	const [loading, setLoading] = useState(false)
	const handleRefresh = async () => {
		if (!dossier) return
		try {
			setLoading(true)
			if (onRefreshRepere) await onRefreshRepere()
		} catch (err) {
			console.error(err)
		} finally {
			onCancel()
			setLoading(false)
		}
	}

	return (
		<Modal
			title={`Paiement en attente ${dossier?.NO_DOSSIER ?? ''}`}
			primaryButtonText={`J'ai payé`}
			cancelButtonText={pageData?.assets?.cancel}
			showExitBtn
			// shouldNotClose
			isOpen={isOpen}
			onCancelBtn={onCancel}
			onPrimaryButton={() => {
				document.getElementById('refresh-submit')?.click()
			}}
			onSetIsOpen={() => {}}
			lessPadding
		>
			{loading ? (
				<Loader text={pageData?.assets?.loading} />
			) : (
				<Formik
					initialValues={{
						motif: ''
					}}
					onSubmit={() => void handleRefresh()}
					style={{ padding: '10px' }}
				>
					{({ errors, touched, handleSubmit }) => (
						<form onSubmit={handleSubmit}>
							<label
								className={errors.motif && touched.motif ? 'text-error' : ''}
							>
								{errors.motif && touched.motif && (
									<div style={{ marginTop: 6 }} className="text-error">
										{pageData?.assets?.[errors.motif] ?? errors.motif}
									</div>
								)}
							</label>

							{description && (
								<div>
									<Text content={description} />
								</div>
							)}

							<button
								id="refresh-submit"
								type="submit"
								style={{ display: 'none' }}
								aria-hidden
							/>
						</form>
					)}
				</Formik>
			)}
		</Modal>
	)
}

export default PaymentRedirectModal
